/** @jsxImportSource @emotion/react */
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { useMutation } from "@tanstack/react-query";
import secondaryButtonCss from "assets/css/buttons/secondaryButton.css";
import { ReactComponent as IconDownload } from "assets/icons/Download.svg";
import getInsightsCSV from "api/insights/getInsightsCsv";
import usePaginationSortSearchQueryParams from "hooks/usePaginationSortSearchQueryParams";
import { URL_KEYS } from "constants/dashboard";
import useEvent from "hooks/useEvent";
import useRouterSearchParams from "hooks/useRouterSearchParams";

export default function ExportInsightsButton({ data, isFetching, isLoading }) {
  const [searchParams] = useRouterSearchParams();
  const urlParams = usePaginationSortSearchQueryParams();

  const current = data?.length;

  const { isMutateLoading, mutate } = useMutation({
    mutationFn: getInsightsCSV,
  });

  const onExportClick = useEvent(() => {
    const partnerId = searchParams.get(URL_KEYS.partnerId) || undefined;
    const categoryId = searchParams.get(URL_KEYS.categoryId) || undefined;
    const brandIds = searchParams.get(URL_KEYS.brandIds) || undefined;
    const excludeBrandIds = searchParams.get(URL_KEYS.excludeBrandIds) || undefined;
    const insightful = searchParams.get(URL_KEYS.insightful) || undefined;

    const queryParams = {
      ...urlParams,
    };
    const filters = {
      partnerId,
      brandIds,
      excludeBrandIds,
      categoryId,
      insightful,
    };
    mutate(
      { queryParams, filters },
      {
        onSuccess: ({ message }) => {
          toast.success(message || "Export started! You will receive an email shortly.");
        },
        onError: (err) => {
          toast.error(err?.message || "Export failed to start.");
        },
      },
    );
  });

  return (
    <button
      type="button"
      css={secondaryButtonCss}
      onClick={onExportClick}
      disabled={isMutateLoading || isFetching || isLoading || !current}
    >
      <IconDownload />
    </button>
  );
}

ExportInsightsButton.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  isFetching: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
